import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "menu-item px-3" }
const _hoisted_8 = {
  key: 0,
  class: "card-body"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-alt" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-folder" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_14 = { class: "menu-item px-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Overview ")
], -1)
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "card mt-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Content Mapping ")
], -1)
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuickAction = _resolveComponent("QuickAction")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PageStatus = _resolveComponent("PageStatus")!
  const _component_DateTimeFormat = _resolveComponent("DateTimeFormat")!
  const _component_KtDatatable = _resolveComponent("KtDatatable")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ShortPageForm = _resolveComponent("ShortPageForm")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.pageEntity.data.name), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_QuickAction, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.pageEntity.data.type==='COLLECTION')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:void(0);",
                          class: "menu-link px-3",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAdd('FOLDER')))
                        }, "Add Folder"))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      class: "menu-link px-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAdd('PAGE')))
                    }, "Add Doc"),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      class: "menu-link px-3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onEdit(_ctx.pageEntity.data)))
                    }, "Edit"),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      class: "menu-link px-3 text-danger",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDeleteEntity(_ctx.pageEntity.data)))
                    }, "Delete")
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.listPage.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_KtDatatable, {
                  "table-data": _ctx.listPage.data.data,
                  "table-header": _ctx.tableHeader,
                  "enable-items-per-page-dropdown": false,
                  "current-page": _ctx.filter.paginationPage,
                  "rows-per-page": _ctx.filter.paginationSize,
                  onItemsPerPageChange: _ctx.handleUpdateSize,
                  onCurrentChange: _ctx.handleUpdatePage,
                  total: _ctx.listPage.data.total
                }, {
                  "cell-name": _withCtx(({ row: page }) => [
                    (page.type==='PAGE')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/doc/`+ page.id
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(page.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/doc/folder/`+ page.id
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createTextVNode(" " + _toDisplayString(page.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                  ]),
                  "cell-createdBy": _withCtx(({ row: page }) => [
                    (page.createdBy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_Avatar, {
                            avatar: page.createdBy?.avatar,
                            "user-id": page.createdBy?.id?.toString()
                          }, null, 8, ["avatar", "user-id"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(page.createdBy?.fullName), 1)
                  ]),
                  "cell-status": _withCtx(({ row: page }) => [
                    (page.type==='PAGE')
                      ? (_openBlock(), _createBlock(_component_PageStatus, {
                          key: 0,
                          status: page.status
                        }, null, 8, ["status"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_13
                        ], 64))
                  ]),
                  "cell-date": _withCtx(({ row: page }) => [
                    _createVNode(_component_DateTimeFormat, {
                      date: page.dateCreated
                    }, null, 8, ["date"])
                  ]),
                  "cell-actions": _withCtx(({row:page }) => [
                    _createVNode(_component_QuickAction, { size: "w-150px" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "menu-link px-3",
                            onClick: ($event: any) => (_ctx.onEdit(page))
                          }, "Edit", 8, _hoisted_15),
                          (page.type ==='PAGE')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (page.status === 'DRAFT')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: "javascript:void(0);",
                                      class: "menu-link px-3",
                                      onClick: ($event: any) => (_ctx.updateStatus(page.id, 'PUBLISHED'))
                                    }, "Publish", 8, _hoisted_16))
                                  : _createCommentVNode("", true),
                                (page.status === 'PUBLISHED')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "javascript:void(0);",
                                      class: "menu-link px-3",
                                      onClick: ($event: any) => (_ctx.updateStatus(page.id, 'DRAFT'))
                                    }, "UnPublish", 8, _hoisted_17))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "menu-link px-3 text-danger",
                            onClick: ($event: any) => (_ctx.onDeleteItem(page))
                          }, "Delete", 8, _hoisted_18)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header", "current-page", "rows-per-page", "onItemsPerPageChange", "onCurrentChange", "total"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Row, { row: [{name:'Created By', slot:true, key: 'createdBy'}] }, {
              createdBy: _withCtx(() => [
                (_ctx.pageEntity.data?.createdBy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_Avatar, {
                        avatar: _ctx.pageEntity.data?.createdBy?.avatar,
                        "user-id": _ctx.pageEntity.data?.createdBy?.id?.toString()
                      }, null, 8, ["avatar", "user-id"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.pageEntity.data?.createdBy?.fullName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Row, {
              row: [{name:'Created', value :_ctx.pageEntity.data.dateCreated, type:'DATE' }]
            }, null, 8, ["row"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Row, {
              row: [{name:'Key', value :_ctx.pageEntity.data.key }]
            }, null, 8, ["row"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Panel, {
      name: _ctx.state.title,
      show: _ctx.state.show,
      onClose: _ctx.onClosePanel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_ShortPageForm, {
              page: _ctx.model,
              id: _ctx.state.id,
              onClosePanel: _ctx.onSavePage
            }, null, 8, ["page", "id", "onClosePanel"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["name", "show", "onClose"])
  ], 64))
}